import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isLogin } from './utils';

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      if (isLogin()) {
        return <Component {...props} />;
      } else {
        localStorage.setItem('redirectAfterLogin', props.location.pathname);
        if(props.location.search.includes('PWA=true')){
          return <Redirect to="/sign?PWA=true" />;
        }
        return <Redirect to="/sign" />;
      }
    }}
  />
);

export const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      !isLogin() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={
            localStorage.getItem('redirectAfterLogin') || 
            '/'
          }
        />
      )
    }
  />
);

export const PublicRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      localStorage.setItem('redirectAfterLogin', props.location.pathname);
      return <Component {...props} />;
    }}
  />
);